import { useAuth, useUser } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router";

import { LoaderTeamz } from "@/components/ui/loader-teamz";
import { useMe } from "@/context/user-context";
import { useTRPC } from "@/lib/trpc";
import { routes } from "@/routes";

export function PublicRoute() {
  const { isSignedIn } = useAuth();

  if (!isSignedIn) {
    return <Outlet />;
  }

  return <Navigate to={routes.profile} />;
}

export function ProtectedRoute() {
  const { isSignedIn } = useUser();

  if (!isSignedIn) {
    return <Navigate to={routes.signup} />;
  }

  return <Outlet />;
}

export function OnboardingRoute() {
  const trpc = useTRPC();
  // Même source de vérité que `Layout` (la ligne de profil en base) : les deux
  // gardes doivent lire la même valeur, sinon elles se renvoient la balle en
  // boucle. En cas d'erreur de `getMe`, l'onboarding reste accessible.
  const { data: user, status } = useQuery(trpc.user.getMe.queryOptions(undefined, {
    retryOnMount: false,
  }));

  if (status === "pending") {
    return (
      <div className="h-dvh w-full">
        <LoaderTeamz />
      </div>
    );
  }

  // Même destination que les formulaires d'onboarding, sinon les deux redirections
  // se courent l'une après l'autre : un club fraîchement inscrit arrive sur la liste
  // joueurs (teaser anonymisé s'il n'est pas abonné), là où son profil vide ne montre
  // rien.
  if (user?.hasProfile) {
    return <Navigate to={user.role === "club" ? routes.players : routes.profile} />;
  }

  return <Outlet />;
}

export function AdminRoute() {
  const { user } = useMe();

  if (!user.isAdmin) {
    return <Navigate to={routes.profile} />;
  }

  return <Outlet />;
}
